import { Divider as MuiDivider, styled, Typography } from '@mui/material';

export const InputTextLabel = styled(Typography)(
  () => `
    font-weight: 400;
  `,
);

export const Container = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const PickerContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: end;
  gap: 6px;
`;

export const Divider = styled(MuiDivider)`
  width: 5%;
  margin-bottom: 25px;
`;
